import { useApplyEdition } from '@/pages/Apply/components/use-apply-edition';
import type { ApplyIdentitiesShow } from '@/types';
import { IdentityForm } from '../components/IdentityForm';
import { LogoutLink } from '../components/LogoutLink';

// app/(public)/${eventSlug}/apply/identity/page.tsx.
export default function Show({
  githubUsername,
  githubAvatarUrl,
  eventName,
}: ApplyIdentitiesShow) {
  const { eventSlug } = useApplyEdition();
  return (
    <>
      <LogoutLink />
      <IdentityForm
        githubUsername={githubUsername}
        githubAvatarUrl={githubAvatarUrl}
        submitUrl={`/${eventSlug}/apply/identity`}
        codeUrl={`/${eventSlug}/apply/identity/code`}
        header={
          <>
            <p className="text-muted-foreground text-sm">{eventName}</p>
            <h1 className="font-bold text-2xl uppercase tracking-wide sm:text-3xl">
              Hola, @{githubUsername}
            </h1>
          </>
        }
      />
    </>
  );
}
